export const routes = {
    home: '/',
    login: '/login',
    dev: '/dev',
    clients: '/clients',
    clientsAdd: '/clients/add',
    clientsEdit: '/clients/edit/:docId',

    equipment: '/equipment',
    equipmentStamps: '/equipment/stamps',
    equipmentStampNew: '/equipment/stamps/new',
    equipmentStamp: '/equipment/stamps/:docId',
    equipmentStampsLabelPrinting: '/equipment/stamps/label-printing',

    equipmentRollers: '/equipment/rollers',
    equipmentFlexoForms: '/equipment/flexo-forms',

    purchases: '/purchases',
    purchasesStampOrders: '/purchases/stamp-orders',
    purchasesStampOrdersCreated: '/purchases/stamp-orders/created',
    purchasesStampOrdersProcessed: '/purchases/stamp-orders/processed',
    purchasesStampOrderNew: '/purchases/stamp-orders/new',
    purchasesStampOrder: '/purchases/stamp-orders/:docId',
    purchasesFlexoFormOrders: '/purchases/flexo-form-orders',
    purchasesMaterialOrders: '/purchases/material-orders',
    purchasesMaterialOrdersTab: '/purchases/material-orders/:tab',
    purchasesMaterialOrderRequests: '/purchases/material-order-requests',

    writeOffs: '/write-offs',
    writeOffsStampWriteOffs: '/write-offs/stamp-write-offs',
    writeOffsStampWriteOffNew: '/write-offs/stamp-write-offs/new',
    writeOffsStampWriteOff: '/write-offs/stamp-write-offs/:docId',

    receipts: '/receipts',
    receiptsMaterialsOld: '/receipts/materials-old',
    receiptsMaterials: '/receipts/materials',
    receiptsMaterialsTab: '/receipts/materials/:tab',
    receiptsFlexoForms: '/receipts/flexo-forms',
    receiptsFlexoFormsTab: '/receipts/flexo-forms/:tab',

    balances: '/balances',
    balancesMaterials: '/balances/materials',
    stampMainPage: '/stamps-main',

    calculations: '/calculations',

    ribbons: '/ribbons',
    orders: '/orders',

    shipments: '/shipments',
    shifts: '/shifts',

    schedulesFlexo: '/schedules/flexo',
    schedulesFlexoTab: '/schedules/flexo/:tab',
    schedulesFlexoMachines: '/schedules/flexo/machines',
    schedulesDigital: '/schedules/digital',
    schedulesRewind: '/schedules/rewind',
    schedulesRewindMachines: '/schedules/rewind/machines',

    designerTasks: '/designer-tasks',
    designerTasksOvertime: '/designer-tasks/overtime',
    curatorTasks: '/curator-tasks',

    templatesBlank: '/templates/blank/:shipmentDocId',

    printPreparation: '/print-preparation',
    consumption: '/consumption',
    technicalCards: '/technical-cards',
    printHistory: '/print-history',
    volumeSummary: '/volume-summary',
    rewindHistory: '/rewind-history',
    completedPrintJobs: '/completed-print-jobs',
    printHistoryTab: '/print-history/:tab',
    profile: '/profile',
}

export const dynamicRoutes = {
    equipmentStamp: (docId: string) => routes.equipmentStamp.replace(':docId', docId),

    purchasesStampOrder: (docId: string) =>
        routes.purchasesStampOrder.replace(':docId', String(docId)),
    purchasesStampOrdersNewByCopy: (copyByQuery: string) =>
        `${routes.purchasesStampOrderNew}?${copyByQuery}`,
    purchasesStampOrdersTab: (tab: 'created' | 'processed') =>
        `${routes.purchasesStampOrders}/${tab}`,
    purchasesMaterialOrdersTab: (tab: string) =>
        routes.purchasesMaterialOrdersTab.replace(':tab', tab),

    receiptsMaterialsTab: (tab: string) => routes.receiptsMaterialsTab.replace(':tab', tab),
    receiptsFlexoFormsTab: (tab: string) => routes.receiptsFlexoFormsTab.replace(':tab', tab),

    schedulesFlexoTab: (tab: string) => routes.schedulesFlexoTab.replace(':tab', tab),

    printHistoryTab: (tab: 'flexo' | 'digital') => routes.printHistoryTab.replace(':tab', tab),

    writeOffsStampWriteOff: (docId: string) =>
        routes.writeOffsStampWriteOff.replace(':docId', docId),

    templatesBlank: (shipmentDocId: string) =>
        routes.templatesBlank.replace(':shipmentDocId', shipmentDocId),

    clientsEdit: (documentId: string) => routes.clientsEdit.replace(':docId', documentId),

    // postComments: (id: string) => routes.postComments.replace(':id', id),
    // post: (id: string) => routes.post.replace(':id', id),
    // postEditing: (id: string) => companyRoutes.postsEditing.replace(':id', id),
    // searchByType: (type: SearchTypes) => routes.searchByType.replace(':type', type),
    // requestByType: (type: RequestTypes) => routes.requestsByType.replace(':type', type),
}
